'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _format = require('date-fns/format');

var _format2 = _interopRequireDefault(_format);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var isPublishedToday = function isPublishedToday(date) {
  var publishDate = (0, _format2.default)(date, 'DD.MM.YYYY');
  var today = (0, _format2.default)(new Date(), 'DD.MM.YYYY');
  return today === publishDate;
};

var DateField = function DateField(_ref) {
  var date = _ref.date,
      dateOnly = _ref.dateOnly;

  if (dateOnly) {
    return date ? (0, _format2.default)(date, 'D.M.YYYY') : null;
  }

  return _react2.default.createElement('span', {
    className: 'date'
  }, date ? (0, _format2.default)(date, isPublishedToday(date) ? 'H:mm' : 'D.M.YYYY') : null);
};

DateField.propTypes = process.env.NODE_ENV !== "production" ? {
  date: _propTypes2.default.string,
  dateOnly: _propTypes2.default.bool
} : {};
exports.default = DateField;
module.exports = exports['default'];